import React, { useContext, useState } from "react";
import { Button, Steps, theme } from "antd";
import { useNavigate } from "react-router";
import { context } from "../context/context";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { toast } from "react-toastify";
import TravelForm from "../components/TravelSuggestion/TravelForm";
import TravelUploadMedia from "../components/TravelSuggestion/TravelUploadMedia";
import { NavLink } from "react-router-dom";

const steps = [
    {
        title: "اضافه کردن جزئیات پیشنهاد سفر",
        content: <TravelForm />,
    },
    {
        title: "انتخاب عکس",
        content: <TravelUploadMedia />,
    },
];
const EditTravelSuggestion = () => {
    const { token } = theme.useToken();
    // state
    const [current, setCurrent] = useState(0);
    // context
    const {
        setTravelCover,
        setTravelMedia,
        textEditorHTML,
        setTravelMediaId,
        travelContent,
        travelCoverId,
        travelGeo,
        travelMediaId,
        travelPlaces,
        travelTags,
        travelTime,
        travelTitle,
        selectedTravelId,
    } = useContext(context);
    // functions
    const next = () => {
        setCurrent(current + 1);
    };
    const navigate = useNavigate();
    const handleSubmit = () => {
        http.post(
            `${config.parkopoloApi}/api/Travel/editTravel/${selectedTravelId}`,
            {
                data: textEditorHTML,
                title: travelTitle,
                coverPic: travelCoverId,
                media: travelMediaId,
                tags: travelTags,
                timescale: travelTime,
                geopolitics: travelGeo,
                places: travelPlaces,
                contents: travelContent,
            }
        )
            .then((res) => {
                toast.success("پیشنهاد سفر با موفقیت ویرایش شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(res.data.success);
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
        setTravelMedia([]);
        setTravelMediaId([]);
        setTravelCover();
        navigate("/travelSuggestion", { replace: true });
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        lineHeight: "260px",
        textAlign: "center",
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };
    return (
        <div style={{ direction: "ltr" }}>
            <Steps current={current} items={items} />
            <div style={contentStyle}>{steps[current].content}</div>
            <div
                style={{
                    marginTop: 24,
                    textAlign: "left",
                    display: "flex",
                    gap: 10,
                }}
            >
                {current < steps.length - 1 && (
                    <Button
                        type="primary"
                        onClick={() => next()}
                        disabled={
                            current === 0 &&
                            (!travelTitle ||
                                travelContent.length === 0 ||
                                travelTitle === "" ||
                                travelGeo.length === 0 ||
                                travelPlaces.length === 0 ||
                                travelTime.length === 0)
                        }
                    >
                        مرحله بعد
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button
                        disabled={!travelCoverId || travelCoverId === ""}
                        type="primary"
                        onClick={() => handleSubmit()}
                    >
                        ثبت
                    </Button>
                )}
                {
                    <NavLink to="/travelSuggestion">
                        <Button type="primary" danger>
                            لغو
                        </Button>
                    </NavLink>
                }
            </div>
        </div>
    );
};

export default EditTravelSuggestion;
